import { MaintenanceDefect } from '../../types';
import { extractTime, isoDatePart } from './dateTimeUtils';

const COMPLETE_TIME_PATTERN = /^\d{2}:\d{2}$/;

export interface DefectCompletionSyncResult {
  defects: MaintenanceDefect[];
  autoPopulatedDefectIds: Set<number>;
}

function hasCompletionEntry(defect: MaintenanceDefect): boolean {
  return Boolean(defect.defectCompletionDate?.trim() || defect.defectCompletionTime?.trim());
}

/**
 * Synchronizes session-auto-populated completions with Final ERTS while leaving
 * completion entries that existed before synchronization unchanged.
 */
export function syncDefectCompletionsWithFinalErts(
  defects: MaintenanceDefect[],
  finalErtsZulu: string,
  autoPopulatedDefectIds: ReadonlySet<number>,
): DefectCompletionSyncResult {
  const completionDate: string = isoDatePart(finalErtsZulu);
  const completionTime: string = extractTime(finalErtsZulu);
  const nextAutoPopulatedIds: Set<number> = new Set<number>(autoPopulatedDefectIds);
  if (!completionDate || !COMPLETE_TIME_PATTERN.test(completionTime)) {
    return { defects, autoPopulatedDefectIds: nextAutoPopulatedIds };
  }

  const synchronizedDefects: MaintenanceDefect[] = defects.map(
    (defect: MaintenanceDefect): MaintenanceDefect => {
      const isAutoPopulated: boolean = nextAutoPopulatedIds.has(defect.id);
      if (!isAutoPopulated && hasCompletionEntry(defect)) return defect;
      nextAutoPopulatedIds.add(defect.id);
      return {
        ...defect,
        defectCompletionDate: completionDate,
        defectCompletionTime: completionTime,
      };
    },
  );
  return { defects: synchronizedDefects, autoPopulatedDefectIds: nextAutoPopulatedIds };
}
